export default {
  productDetail: {
    // Tipos de cambio
    typeNewEntry: "Nueva entrada",
    typePriceChange: "Cambio precio",
    typeReimbursementChange: "Financiación",
    typeExclusion: "Exclusión",
    typeDeduction: "Deducción",
    typeWarning: "Nota",
    typeMarketingStatus: "Comercialización",
    typeEuRegistration: "Registro europeo",
    typeExclusivity: "Exclusividad",

    // Etiquetas de cartera
    competitor: "Competidor",
    others: "Otros",

    // Cabecera
    productFallback: "Producto CN {cn}",
    registrationNo: "Nº Registro",
    close: "Cerrar",
    loading: "Cargando ficha…",

    // Identificación y laboratorio
    identificationSection: "Identificación y laboratorio",
    activeIngredient: "Principio activo",
    holderLab: "Laboratorio titular",
    marketerLab: "Laboratorio comercializador",
    pharmaceuticalForm: "Forma farmacéutica",
    administrationRoute: "Vía administración",
    dose: "Dosis",
    therapeuticArea: "Área terapéutica",

    // Clasificación ATC
    // Agrupación homogénea (R-05, §90 Fase 2A)
    exclSection: "Protección y exclusividad",
    exclEuNumber: "Número UE",
    exclFirstAuth: "Primera autorización en la UE",
    exclPast: "ya vencido",
    exclDaysLeft: "faltan {n} días",
    exclSubject: "+1 año sujeto a confirmación",
    exclCalculated: "fecha calculada",
    ahSection: "Agrupación homogénea",
    ahCode: "Agrupación",
    ahMembers: "Presentaciones en la AH",
    ahMembersValue: "{n} CN",
    ahLowestPrice: "Precio menor de la AH",
    ahOwnPrice: "Precio de esta presentación",
    ahPrevious: "AH anterior",
    atcSection: "Clasificación ATC",
    level: "nivel {n}",

    // Estado regulatorio
    regulatoryStatusSection: "Estado regulatorio",
    marketed: "Comercializado",
    yes: "Sí",
    no: "No",
    authorizationDate: "Fecha autorización",
    suspensionDate: "Fecha suspensión",
    prescription: "Receta",
    prescriptionRequired: "Sujeto a receta médica",
    prescriptionNotRequired: "Sin receta",
    noPresentation: "Sin presentación comercializada",
    noPresentationAut: "Desde su autorización, el {date} ({n} meses). A los 3 años la autorización puede caducar.",
    noPresentationCese: "Desde el último cese conocido, el {date} ({n} meses). A los 3 años la autorización puede caducar.",
    smpcWatch: "Ficha técnica (comparación por secciones)",
    smpcHtml: "Sí, ficha de CIMA",
    smpcOriginal: "Sí, ficha del medicamento original (importación paralela)",
    smpcPdf: "Sí, ficha en PDF de CIMA",
    smpcPending: "Pendiente de la primera lectura",
    smpcUnavailable: "Comparación no disponible: CIMA no publica la ficha técnica",
    notSubstitutable: "No sustituible",
    generic: "Genérico",
    biosimilar: "Biosimilar",
    orphan: "Huérfano",
    triangle: "▼ Triángulo (seg. adicional)",
    supplyProblems: "Problemas suministro",

    // Financiación SNS
    financingSection: "Financiación SNS (Bifimed)",
    financingStatus: "Situación financiación",
    type: "Tipo",
    nomenclator: "Nomenclátor",
    noBifimedData: "Sin datos en Bifimed para este CN.",

    // Presentaciones
    presentationsSection: "Presentaciones ({n})",
    notMarketed: "No comercializado",

    // Documentos
    documentsSection: "Documentos AEMPS",
    datasheet: "Ficha técnica",
    leaflet: "Prospecto",

    // Excipientes
    excipientsSection: "Excipientes ({n})",

    // Histórico de cambios
    historySection: "Histórico de eventos detectados ({n})",
    noChanges: "No hay eventos registrados para este CN.",
    conceptGenericFinanced: "PVL genérico financiado",
    conceptLowerPriceAH: "PVL precio menor AH (Ley 29/2006)",
    conceptMandatoryDeduction: "Deducción obligatoria (RDL 8/2010)",
    conceptAuthorizationDate: "Fecha autorización",
    conceptSafetyNote: "Nota de seguridad",
    conceptBoeResolution: "Resolución BOE",
    aiSummary: "Resumen IA",
    viewAempsNote: "Ver nota AEMPS ↗",
  },
};
